module.exports = __webpack_public_path__ + "img/Frame-2.ebefdb4.png";